import { render, staticRenderFns } from "./FtaAreaInfo.vue?vue&type=template&id=2daadb5c&scoped=true"
import script from "./FtaAreaInfo.vue?vue&type=script&lang=js"
export * from "./FtaAreaInfo.vue?vue&type=script&lang=js"
import style0 from "../fta.css?vue&type=style&index=0&id=2daadb5c&prod&scoped=true&lang=css&external"
import style1 from "./FtaAreaInfo.less?vue&type=style&index=1&id=2daadb5c&prod&lang=less&scoped=true&external"
import style2 from "./FtaAreaInfo.vue?vue&type=style&index=2&id=2daadb5c&prod&scoped=true&lang=less"
import style3 from "./FtaAreaInfo.vue?vue&type=style&index=3&id=2daadb5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daadb5c",
  null
  
)

export default component.exports